'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleOverlayClick = function handleOverlayClick() {
  PubSub.publish(_Constants2.default.hideOverlay, {});
};

var bindActions = exports.bindActions = function bindActions() {
  $(_Dom2.default.overlay).on('click', handleOverlayClick);
};